import { menuLinkStyle } from "./shared"
import React from "react"
import PropTypes from "prop-types"
import I18n from "lib/i18n"
import clsx from "classnames"

const DashboardLink = ({
  user = undefined,
  userRole = "Reader",
  allowedRoles = ["Editor", "Author"],
}) => {
  if (!user?.id || !allowedRoles.includes(userRole)) {
    return null
  }

  const dashboardLink =
    userRole === "Editor" ? `/editorial/dashboards/${user.id}` : `/profiles/${user.id}/dashboard`

  return (
    <a className={clsx(menuLinkStyle)} href={dashboardLink}>
      {I18n.t("top_bar.label.dashboard")}
    </a>
  )
}

DashboardLink.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  userRole: PropTypes.string.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
}

export default DashboardLink
